document.addEventListener("DOMContentLoaded", function() {
  
  const headings = document.querySelectorAll('.card-overlay-heading');
  headings.forEach(function(heading) {
    
    if (heading.textContent.trim().startsWith('Brand')) {
      const gridItem = heading.closest('.grid-item');
      if (gridItem) {
        gridItem.remove(); // This removes the entire parent grid item from the DOM
      }
    }
  });
});
